var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#525252"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.142 9.929l-6.364 6.364a1 1 0 01-1.415 0L5 9.929",
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTmpSd2VDSWdhR1ZwWjJoMFBTSTJOSEI0SWlCMmFXVjNRbTk0UFNJd0lEQWdNalFnTWpRaUlHWnBiR3c5SW01dmJtVWlJSGh0Ykc1elBTSm9kSFJ3T2k4dmQzZDNMbmN6TG05eVp5OHlNREF3TDNOMlp5SWdjM1J5YjJ0bFBTSWpOVEkxTWpVeUlpQWdhV1E5SW01bGVIUWlQZ29nSUR4bklHbGtQU0pUVmtkU1pYQnZYMkpuUTJGeWNtbGxjaUlnYzNSeWIydGxMWGRwWkhSb1BTSXdJajQ4TDJjK0NpQWdQR2NnYVdROUlsTldSMUpsY0c5ZmRISmhZMlZ5UTJGeWNtbGxjaUlnYzNSeWIydGxMV3hwYm1WallYQTlJbkp2ZFc1a0lpQnpkSEp2YTJVdGJHbHVaV3B2YVc0OUluSnZkVzVrSWo0OEwyYytDaUFnUEdjZ2FXUTlJbE5XUjFKbGNHOWZhV052YmtOaGNuSnBaWElpUGdvZ0lDQWdQSEJoZEdnZ1pEMGlUVEU1TGpFME1UWWdPUzQ1TWpnNU5rd3hNaTQzTnpjMklERTJMakk1TWpsRE1USXVNemczTVNBeE5pNDJPRE0wSURFeExqYzFNemtnTVRZdU5qZ3pOQ0F4TVM0ek5qTTBJREUyTGpJNU1qbE1OQzQ1T1RrME5pQTVMamt5T0RrMUlpQnpkSEp2YTJVOUlpTTFNalV5TlRJaUlITjBjbTlyWlMxc2FXNWxZMkZ3UFNKeWIzVnVaQ0krUEM5d1lYUm9QZ29nSUR3dlp6NEtQQzl6ZG1jKyI=";
export { SvgCaretDown as ReactComponent };